import angular from 'angular';

const filtersModule = angular.module('ngeoAngularFilters');

filtersModule.filter('formatData', function () {
    return function (input) {
        try {
            if (input === null || input === undefined) {
                return '';
            }

            if (typeof input === 'boolean') {
                return input ? 'Ja' : 'Nein';
            }

            if (typeof input === 'string') {
                /* BOOLEANS */
                const val = input.trim().toLowerCase();
                if (val === 'true') {
                    return 'Ja';
                }
                if (val === 'false') {
                    return 'Nein';
                }

                /* DATES */
                // Format ISO UTC : yyyy-mm-ddTHH:MM:SSZ
                const isoUtcRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;
                // Format ISO UTC : yyyy-mm-ddTHH:MM:SS.ddd
                const isoUtcMsRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}$/;
                // Simple inverted format : yyyy-mm-dd
                const simpleDateRegex = /^\d{4}-\d{2}-\d{2}$/;
                // Simple inverted format with time : yyyy-mm-dd HH:MM:SS
                const simpleDatetimeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
                if (isoUtcRegex.test(input) || isoUtcMsRegex.test(input) || simpleDateRegex.test(input) || simpleDatetimeRegex.test(input)) {
                    const date = new Date(input);
                    const days = date.getDate().toString().padStart(2, '0');
                    const month = (date.getMonth() + 1).toString().padStart(2, '0');
                    const year = date.getFullYear();

                    const hours = date.getHours().toString().padStart(2, '0');
                    const minutes = date.getMinutes().toString().padStart(2, '0');
                    const seconds = date.getSeconds().toString().padStart(2, '0');

                    if (hours === '00' && minutes === '00' && seconds === '00') {
                        // Date without time
                        return `${days}.${month}.${year}`;
                    }

                    // Date with time
                    return `${days}.${month}.${year}&nbsp;${hours}:${minutes}:${seconds}`;
                }
            }
        }
        catch {
            // Do nothing here.
            // The return value will just be the unchanged string
        }

        return input;
    };
});
